/**
 * Controla la tabla de inspecciones.
 */
CamposExtraDetallesCtrl.$inject = ['$q', '$scope', 'CampoExtra'];
export default function CamposExtraDetallesCtrl($q, $scope, CampoExtra) {

    var campExtDet = this;

    var soloObligatorios = issetAndNotEmpty(campExtDet.onlyRequired) ? campExtDet.onlyRequired : false;
    campExtDet.cargando = true;
    campExtDet.camposExtra = [];

    campExtDet.updateActive = false;

    campExtDet.puedeEditarCamposExtra = Sigo.user.puedeEditarCamposExtra;

    campExtDet.actualizar = actualizar;
    $scope.actualizar = actualizar;

    campExtDet.actualizar();

    function actualizar() {
        campExtDet.cargando = true;
        campExtDet.updateActive = false;

        CampoExtra.get(campExtDet.modelId, soloObligatorios)
            .then(function (data) {
                if (isArray(data.data) && data.data.length > 0) {
                    campExtDet.camposExtra = chunkArray(data.data, 4);
                    $('#' + campExtDet.tagId + '[data-id="' + campExtDet.modelId + '"]').parent().removeClass('ocultar');
                } else {
                    $('#' + campExtDet.tagId + '[data-id="' + campExtDet.modelId + '"]').parent().addClass('ocultar');
                }
                campExtDet.cargando = false;
            }, function (err) {
                campExtDet.cargando = false;
            });
    }

    campExtDet.obtenerClases = function(campoExtra){
        if (campoExtra.json != null && campoExtra.json != ""){
            var json = angular.fromJson(campoExtra.json);
            if (typeof json.clases !== "undefined"){
                return json.clases;
            }
        }
      return ["three"];
    };
    campExtDet.actualizaCamposExtra = function () {
        campExtDet.cargando = true;

        var promesas = [];

        for (var i = 0; i < campExtDet.camposExtra.length; i++) {
            for (var j = 0; j < campExtDet.camposExtra[i].length; j++) {
                var campoExtra = campExtDet.camposExtra[i][j];
                if (issetAndNotEmpty(campoExtra.changed) && campoExtra.changed) {
                    campoExtra.changed = false;
                    promesas.push(
                        campoExtra.valor != null
                            ? CampoExtra.update(campExtDet.modelId,
                            {
                                campoExtraId: campoExtra.id,
                                valor: campoExtra.valor,
                                valor_descripcion: campoExtra.valor_descripcion,
                                valor_json: campoExtra.valor_json
                            })
                            : CampoExtra.delete(campExtDet.modelId, campoExtra.id)
                    );
                }
            }
        }

        $q.all(promesas).then(function () {
            actualizar();
            campExtDet.cargando = false;
        }, function () {
            campExtDet.cargando = false;
        });
    };

    campExtDet.actualizaUpdateActive = function () {
        if (campExtDet.updateActive)
            actualizar();
        else
            campExtDet.updateActive = !campExtDet.updateActive;
    };
}